// src/client/renderer/shaders/waterfall.ts
import * as THREE from 'three';
import type { ShaderFactory } from './types';
import { VERTEX as WATERFALL_VERTEX, FRAGMENT as WATERFALL_FRAGMENT } from './waterfall.glsl';

export interface WaterfallUniforms {
  uTime: THREE.IUniform<number>;
  /** Scroll speed (UV/sec). Default: 1.5. */
  uScrollSpeed: THREE.IUniform<number>;
  /** Default: (0.95, 0.98, 1.0). */
  uFoamColor: THREE.IUniform<THREE.Color>;
  /** Default: (0.3, 0.6, 0.85). */
  uBodyColor: THREE.IUniform<THREE.Color>;
  /** Default: 6.0. */
  uStripeFrequency: THREE.IUniform<number>;
}

export const createWaterfallShader: ShaderFactory = () => {
  const uniforms: WaterfallUniforms = {
    uTime: { value: 0 },
    uScrollSpeed: { value: 1.5 },
    uFoamColor: { value: new THREE.Color(0.95, 0.98, 1.0) },
    uBodyColor: { value: new THREE.Color(0.3, 0.6, 0.85) },
    uStripeFrequency: { value: 6.0 },
  };
  return new THREE.ShaderMaterial({
    uniforms: uniforms as unknown as Record<string, THREE.IUniform<unknown>>,
    vertexShader: WATERFALL_VERTEX,
    fragmentShader: WATERFALL_FRAGMENT,
    side: THREE.DoubleSide,
    transparent: true,
    depthWrite: false,
  });
};
